// Adapter puro: convierte el resultado de decodeView (un .epcp de UNA vista) a la
// estructura que ya consume el render del visor, para que el camino binario y el
// camino JSON sean intercambiables sin tocar Render.
//
// Salida por pictograma: { labels, entitiesByType: { [view]: [entidades] } }, donde
// cada entidad es { id, x, y, width, height, type, layerName, status }. El estado
// (status) todavía NO viene en el binario (llegará en vivo de Mongo); con status
// null el render pinta en gris (NO_STATUS), que es el comportamiento esperado.

export function decodedToScenes(decoded, view) {
  const scenes = {}
  const { directory, geometry, entityIds, layerCodes, layers } = decoded

  for (const dir of directory) {
    const entities = []
    const start = dir.entityOffset

    for (let i = 0; i < dir.entityCount; i++) {
      const idx = start + i
      const g = idx * 4
      const layer = layers[layerCodes[idx]]

      entities.push({
        id: String(entityIds[idx]),
        x: geometry[g],
        y: geometry[g + 1],
        width: geometry[g + 2],
        height: geometry[g + 3],
        type: view,
        layerName: layer ? layer.name : null,
        status: null, // vendrá de Mongo en una fase posterior
      })
    }

    scenes[dir.pictogramId] = {
      labels: [],
      entitiesByType: { [view]: entities },
    }
  }

  return scenes
}
